import React from 'react';
interface Props {
  eyebrow?: string;
  title: React.ReactNode;
  subtitle?: string;
  align?: 'left' | 'center';
  light?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center',
  light = false
}: Props) {
  return <div className={align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl'} data-id="element-116" data-mp="3f36ptgzlrl63">
      {eyebrow && <div className={`mb-3 flex items-center gap-2 ${align === 'center' ? 'justify-center' : ''}`} data-id="element-117" data-mp="3k202x8az9a5q">
          <span className="h-[3px] w-8 bg-jk-red" data-id="element-118" data-mp="bmpwxp3yvkso" />
          <span className="font-display text-sm font-bold uppercase tracking-[0.25em] text-jk-red" data-id="element-119" data-mp="gi56i4uxyuja">{eyebrow}</span>
        </div>}
      <h2 className={`font-display text-4xl font-extrabold uppercase leading-[1] tracking-tight sm:text-5xl sm:leading-[0.95] ${light ? 'text-jk-ink' : 'text-white'}`} data-id="element-120" data-mp="1shczpt05064">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed ${light ? 'text-black/60' : 'text-white/65'}`} data-id="element-121" data-mp="z9y2871eatup">{subtitle}</p>}
    </div>;
}